import { render, staticRenderFns } from "./BnOffsetCard.vue?vue&type=template&id=59e8f9c8&scoped=true&"
import script from "./BnOffsetCard.vue?vue&type=script&lang=js&"
export * from "./BnOffsetCard.vue?vue&type=script&lang=js&"
import style0 from "./BnOffsetCard.vue?vue&type=style&index=0&id=59e8f9c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e8f9c8",
  null
  
)

export default component.exports